module.exports = __webpack_public_path__ + "img/bintang.e5357b55.svg";